import { render } from "./yieldcheck.vue?vue&type=template&id=122c410c&ts=true"
import script from "./yieldcheck.vue?vue&type=script&lang=ts"
export * from "./yieldcheck.vue?vue&type=script&lang=ts"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__